import { Typography, styled } from '@mui/material'

const ErrorMessage = styled('div')({
  display: 'flex',
  justifyContent: 'start',
  alignItems: 'center',
  width: '100%',
  gap: '0.5rem',
  color: 'var(--dewi_colors_red_6)',
  '& > .MuiTypography-root': {
    fontSize: '1rem',
    lineHeight: 'unset',
  },
})

type DialogErrorMessageProps = {
  Icon: any
  message: string
}

export const DialogErrorMessage = ({
  Icon,
  message,
}: DialogErrorMessageProps) => {
  return (
    <ErrorMessage>
      <Icon /> <Typography>{message}</Typography>
    </ErrorMessage>
  )
}
